/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog, { LogTypes } from "../Utility/ComponentLogger";

/** @hidden */
const ccclass = cc._decorator.ccclass;
/** @hidden */
const property = cc._decorator.property;

/** A State used by the special [[StateMachine]] class used by [[Reel]]s. */
@ccclass
export default class State extends cc.Component
{
    /** [[cc.Component.EventHandler]]s to be dispatched when this state is entered. */
    @property(
    {
        tooltip: "i18n:COMPONENT.button.click_events",
        type: cc.Component.EventHandler
    })
    private onEnter: cc.Component.EventHandler[] = [];

    /** [[cc.Component.EventHandler]]s to be dispatched when this state is exited. */
    @property(
        {
            tooltip: "i18n:COMPONENT.button.click_events",
            type: cc.Component.EventHandler
        })
    private onExit: cc.Component.EventHandler[] = [];

    /** Called by [[StateMachine]] when this state is entered. */
    public Enter(): void
    {
        // CLog.log("Enter State: " + this.name, LogTypes.Reel, this);

        for (let eventHandler of this.onEnter)
        {
            if (eventHandler != null)
            {
                eventHandler.emit([eventHandler.customEventData]);
            }
        }
    }

    /** Called by [[StateMachine]] when this state is exited. */
    public Exit(): void
    {
        // CLog.log("Exit State: " + this.name, LogTypes.Reel, this);

        for (let eventHandler of this.onExit)
        {
            eventHandler.emit([eventHandler.customEventData]);
        }
    }
}
